export enum ReferralCampaignTypes {
  PERCENT = 'gofast-custom-percent',
  MONEY = 'gofast-custom-money',
  GOFAST = 'gofast',
}
